import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=792c1228&scoped=true"
import script from "./TermsCondition.vue?vue&type=script&lang=js"
export * from "./TermsCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsCondition.vue?vue&type=style&index=0&id=792c1228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c1228",
  null
  
)

export default component.exports